var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"auth_in"},[(
        _vm.getFormState === 'signIn' || _vm.getFormState === 'forceChangePassword'
      )?_c('sign-in'):_vm._e(),(
        _vm.getFormState === 'refreshPassword' ||
        _vm.getFormState === 'refreshPasswordSubmit'
      )?_c('refresh-password'):_vm._e(),_c('br'),_c('br'),(_vm.getFormState === 'signUp')?_c('div',[_c('p',{staticClass:"toggle",on:{"click":_vm.toSignIn}},[_vm._v(" すでにユーザー登録済みですか? サインインはこちら ")]),_c('br')]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }